/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Results waiting for review in one workshop's queue.
 * @export
 * @interface ReviewWorkshopCount
 */
export interface ReviewWorkshopCount {
    /**
     * 
     * @type {string}
     * @memberof ReviewWorkshopCount
     */
    workshop_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewWorkshopCount
     */
    workshop_name: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewWorkshopCount
     */
    count: number;
}

/**
 * Check if a given object implements the ReviewWorkshopCount interface.
 */
export function instanceOfReviewWorkshopCount(value: object): value is ReviewWorkshopCount {
    if (!('workshop_id' in value) || value['workshop_id'] === undefined) return false;
    if (!('workshop_name' in value) || value['workshop_name'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ReviewWorkshopCountFromJSON(json: any): ReviewWorkshopCount {
    return ReviewWorkshopCountFromJSONTyped(json, false);
}

export function ReviewWorkshopCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewWorkshopCount {
    if (json == null) {
        return json;
    }
    return {
        
        'workshop_id': json['workshop_id'],
        'workshop_name': json['workshop_name'],
        'count': json['count'],
    };
}

export function ReviewWorkshopCountToJSON(json: any): ReviewWorkshopCount {
    return ReviewWorkshopCountToJSONTyped(json, false);
}

export function ReviewWorkshopCountToJSONTyped(value?: ReviewWorkshopCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshop_id': value['workshop_id'],
        'workshop_name': value['workshop_name'],
        'count': value['count'],
    };
}

